var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLegalRequest({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 25,
    height: 25,
    rx: 7.5,
    fill: "#E4EAF8",
    stroke: "#E4EAF8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.125 6H6.875C6.39156 6 6 6.39156 6 6.875V19.125C6 19.6084 6.39156 20 6.875 20H19.125C19.6084 20 20 19.6084 20 19.125V6.875C20 6.39156 19.6084 6 19.125 6ZM18.25 15.625H15.625V17.375H10.375V15.625H7.75V7.75H18.25V15.625Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.875 9.5H12.125V12.125H10.375L13 14.75L15.625 12.125H13.875V9.5Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLegalRequest);
export default __webpack_public_path__ + "static/media/legalRequest.00e8e70d744ff42b371768aa5c278eb6.svg";
export { ForwardRef as ReactComponent };